import { PeriodReport } from '../PeriodReport'

export function TopSelling() {
  return <PeriodReport type="products" />
}
